import { render, staticRenderFns } from "./AlarmSwitch.vue?vue&type=template&id=4de57419&"
import script from "./AlarmSwitch.vue?vue&type=script&lang=js&"
export * from "./AlarmSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports